// extracted by mini-css-extract-plugin
export var categories = "ReferenceCategories-module--categories--d445a";